export { default } from './DocumentCaptureSession';
